// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bpmx","inner":"Footer_inner__3Iagy"};